// extracted by mini-css-extract-plugin
export var chevron = "_2d-2";
export var chevronCollapsed = "_2d-3";
export var collapsibleHeader = "_2d-1";
export var container = "_2d-0";